import React, { useEffect, useState } from "react";
import { ChevronUp } from "lucide-react";
import HeroSlider from "../components/HeroSlider";
import Welcome from "../components/Welcome";
import AboutSnippet from "../components/AboutSnippet";
import Services from "../components/Services";
import Stats from "../components/Stats";
import ProjectsSection from "../components/ProjectsSection";
import WhatWeDo from "../components/WhatWeDo";
import NewsBlog from "../components/NewsBlog";

const ScrollTop = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-8 right-8 z-40 w-12 h-12 rounded-full bg-[#0a2463] hover:bg-[#ff6b00] text-white shadow-lg flex items-center justify-center transition-colors"
      aria-label="Scroll to top"
    >
      <ChevronUp size={22} />
    </button>
  );
};

const Home = () => {
  return (
    <>
      <HeroSlider />
      <Welcome />
            <Stats />

      <AboutSnippet />
      <WhatWeDo />
      <Services />
      <ProjectsSection />
     
      <NewsBlog />
      <ScrollTop />
    </>
  );
};

export default Home;
